import React, { useRef } from 'react';
import { Modal, ModalRef } from 'alurkerja-ui';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { FaUserFriends } from 'react-icons/fa';
import { ActionButton } from '@/components/shared/button/ActionButton';
import { IProjectSchema } from '@/api/project';
import { useCustomSpec } from '@/utils/hooks/useCustomSpec';
import {
  ExtendedTableLowCode,
  ExtendedTableLowCodeRef,
} from '@/components/shared/table/ExtendedTableLowCode';
import { ButtonAssign } from './ButtonAssign';
import { useParams } from 'react-router-dom';
import { useAccess } from '@/utils/hooks/useAccess';
import { IFilterSpec } from '@/components/shared/filter/TableFilterPanel';
import { TestIssueService } from '@/api/testIssue';
import { DeleteAssignee } from './DeleteAssignee';
import { HideCustomCreateButton } from '@/components/shared/button/HideCustomButtonCreate';

type ViewAssigneeProps = {
  project: IProjectSchema;
};

export const ViewAssignee: React.FC<ViewAssigneeProps> = ({ project }) => {
  const { id } = useParams();
  const isViewer = useAccess(id!);

  const ref = useRef<ModalRef>(null);
  const tableRef = useRef<ExtendedTableLowCodeRef>(null);

  const spec = useCustomSpec('/api/crud/project-assignee', {
    columns: [
      { key: 'contributor.full_name', label: 'Users' },
      { key: 'access', label: 'Access' },
      { key: 'contributor.user_type', label: 'Role' },
    ],
  });

  const { data: optionData } = TestIssueService.useGetDropDown(id);
  const optionUser = optionData?.assignee_issue.map(item => ({
    label: item.label,
    value: item.label,
  }));

  const filterSpec: IFilterSpec[] = [
    {
      name: 'contributorId',
      label: 'Fullname',
      type: 'option',
      options: optionUser,
    },
  ];

  return (
    <Modal
      ref={ref}
      title="View Assignees"
      triggerButton={
        <OutlineButton icon={<FaUserFriends />}>View Assignees</OutlineButton>
      }
    >
      <div className="flex flex-col gap-5 p-4">
        <div className="-mx-4">
          <ExtendedTableLowCode
            ref={tableRef}
            spec={spec}
            showFilter={true}
            filterSpec={filterSpec}
            defaultFilter={{ project_id: project.id }}
            customButtonCreate={HideCustomCreateButton}
            customActionCell={data => {
              // TableLowcode can render an action cell before a row is available.
              // Avoid dereferencing an undefined row while the table is loading.
              if (!data?.id) {
                return <></>;
              }

              return !isViewer ? (
                <ActionButton.Wrapper>
                  <ButtonAssign
                    assigneeId={data.id}
                    data={project}
                    onSuccess={() => ref.current?.closeModal()}
                  />
                  <DeleteAssignee
                    projectId={data.id}
                    onSuccess={() => tableRef.current?.refetch()}
                  />
                </ActionButton.Wrapper>
              ) : (
                <></>
              );
            }}
          />
        </div>
      </div>
    </Modal>
  );
};
